import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-profile-detail',
  templateUrl: './profile-detail.component.html',
  styleUrls: ['./profile-detail.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ProfileDetailComponent {
  @Input() userProfile = null;

  get fullName() {
    return `${this.userProfile?.first_name || ''} ${
      this.userProfile?.last_name || ''
    }`.trim();
  }
}
